<template>
  <div>
    <!-- <div ref="linecharts" style="width: 100%; height: 400px"></div> -->
    <div>
      <div class="page-value">
        <div class="title">
          <p>浏览量</p>
          <p>页面</p>
        </div>
        <div class="page-list">
          <div
            v-for="(item, index) in seriesData"
            :key="index"
            class="page-item"
            :style="{
              opacity:  (0.5 + ((10-index) * 5) / 100) ,
            }"
          >
            <p>{{ item.value }}</p>
            <p @click="goPage(item.name)">
              {{ item.name }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: { webData: Object },
  watch: {
    webData(val, newval) {
      this.dataProcessing();
      console.log(this.webData);
    },
  },
  data() {
    return {
      // 热门省份
      seriesData: [],
      label: {
        show: true,
        formatter: [
          "{a|{b} }", //引导线上面文字
          "{b|}", //引导线下面文字
        ].join("\n"), //用\n来换行
        // fontSize: "14",
        // fontWeight: "300",
        color: "#434343",
        position: "outside",
        //a和b来识别不同的文字区域
        rich: {
          a: {
            left: 80,
            top: -10,
            padding: [0, -10, -30, -10],
            fontWeight: "300",
            fontSize: "14",
          },
          b: {
            height: 5,
            width: 5,
            lineHeight: 5,
            marginBottom: 10,
            padding: [0, -5],
            borderRadius: 5,
            borderWidth: 1,
            borderColor: "#4E97D6",
          },
        },
      },
    };
  },
  methods: {
    goPage(item){
      window.open('http://' + item)
    },
    dataProcessing() {
      this.seriesData = [];
      for (let key in this.webData.page_top10) {
        let name = "";
        if (key.indexOf("mobile") != -1) {
          name = "mobile.wupen.org" + key.slice(23);
          if (name == "mobile.wupen.org/") {
            name = "mobile.wupen.org";
          }
        } else {
          name = "wupen.org" + key;
          if (name == "wupen.org/") {
            name = "wupen.org";
          }
        }
        this.seriesData.push({
          value: this.webData.page_top10[key],
          label: this.label,
          name: name,
        });
      }
      // this.createEcharts()
      console.log(this.seriesData);
    },
    createEcharts() {
      let myChart = this.$echarts.init(this.$refs.linecharts);
      // 绘制图表
      myChart.setOption({
        tooltip: {
          backgroundColor: "rgba(50,50,50,0.9)",
          trigger: "item",
          formatter: " {b}: {c}\n ({d}%)",
          borderColor: "transparent",
          borderWidth: "5",
          textStyle: {
            fontSize: "12",
            lineHeight: "12",
            height: "10",
            color: "white",
          },
        },
        series: [
          {
            name: "访问来源",
            type: "pie",

            radius: "70%",
            // data: [
            //   { value: 1048, name: "内蒙古", label: this.label },
            //   { value: 735, name: "宁夏", label: this.label },
            //   { value: 580, name: "安徽", label: this.label },
            //   { value: 484, name: "山东", label: this.label },
            //   { value: 300, name: "湖北", label: this.label },
            // ],
            data: this.seriesData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      });
    },
  },
};
</script>

<style scoped lang="scss">
.page-value {
  margin-left:20px;
  .title {
    display: flex;
    margin-top: 20px;
    p {
      font-weight: bold;
    }
    p:nth-of-type(1) {
      text-align: left;
      width: 100px;
    }
  }
  .page-list {
    .page-item {
      display: flex;
      margin-top: 10px;
      p {
        color: $timeBtn;
      }
      p:nth-of-type(1) {
        color: $lightenYellow;
        text-align: left;
        width: 100px;
      }
      p:nth-of-type(2) {
        color: $timeBtn;
        text-align: left;
        width: 500px;
        cursor: pointer;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/index/HotPage.vue